import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const twingate = defineConnector({
  identifier: "twingate",
  name: "Twingate",
  tagLine: "Zero trust network access",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}.twingate.com/.*`
      : "https://.*.twingate.com/.*",
  auth: (app) => headerAuth([{ name: "X-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Twingate network name",
      items: [
        {
          kind: "input",
          label: "Network name",
          required: true,
          placeholder: "your-network",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "The subdomain of your Twingate network (e.g. your-network.twingate.com).",
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Twingate admin console](https://www.twingate.com/docs/api-overview), go to **Settings › API** and generate a new API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => ({
      url: `https://${domain}.twingate.com/api/graphql/`,
      method: "POST" as const,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        query: "{ resources { edges { node { id name } } } }",
      }),
    }),
  },
});
